import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import './VersionDetailNavbar.scss';

const VersionDetailNavbar = (props) => {
  const { onSubmit, deleteVersion } = props;

  return (
    <FixedBottomNavBar className="version-detail-navbar">
      <div className="button-group">
        <div className="left"></div>
        <div className="right">
          {/*등록하기, 편집하기*/}
          {<Button color="primary" text="저장" onClick={() => onSubmit()} />}

          {/*삭제하기*/}
          {<Button color="gray" text="삭제" onClick={() => deleteVersion()} />}
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default VersionDetailNavbar;
